import { useAuthorization } from "@sttedra_ui/framework";

import UsersView from "../users/UsersView.vue";

export default [
  {
    path: "/admin/Users",
    name: "Users",
    component: UsersView,
    meta: { title: "Usuarios", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
